<div class="overlay__panel__wrapper">
	<ng-container *ngIf="list.length > 0; else empty">
		<div class="overlay__list">
			<div
				class="overlay__item"
				*ngFor="let item of list"
				(click)="openMsgs(item.orderId)"
			>
				<div class="overlay__info">
					<span class="overlay__order">Pedido #{{ item.orderId }}</span>
					<span class="overlay__total"
						>Você tem <strong>{{ item.total }}</strong> mensagem(ns) não
						lida(s)</span
					>
				</div>

				<button
					pButton
					type="button"
					icon="pi pi-arrow-right"
					class="p-button-text p-button-sm"
				></button>
			</div>
		</div>
	</ng-container>

	<ng-template #empty>
		<div class="overlay__empty">
			<p><i class="fa-solid fa-comment-slash"></i> Sem mensagens não lidas.</p>
		</div>
	</ng-template>
</div>
